import { z } from '@kc3/validation';
// Location
export const CreateLocationSchema = z.object({
    name: z.string().min(1).max(255),
    description: z.string().max(1000).optional(),
    shortName: z.string().max(100).optional(),
    code: z.string().max(50).optional(),
    address: z.string().max(500).optional(),
    city: z.string().max(128).optional(),
    cityId: z.number().optional(),
    state: z.string().max(128).optional(),
    stateId: z.number().optional(),
    country: z.string().min(1).max(128),
    countryId: z.number().optional(),
    zip: z.string().max(20).optional(),
    ola: z.string().max(500).optional(),
    isActive: z.boolean().optional().default(true),
});
export const UpdateLocationSchema = z.object({
    name: z.string().min(1).max(255).optional(),
    description: z.string().max(1000).optional().nullable(),
    shortName: z.string().max(100).optional().nullable(),
    code: z.string().max(50).optional().nullable(),
    address: z.string().max(500).optional().nullable(),
    city: z.string().max(128).optional().nullable(),
    cityId: z.number().optional().nullable(),
    state: z.string().max(128).optional().nullable(),
    stateId: z.number().optional().nullable(),
    country: z.string().min(1).max(128).optional(),
    countryId: z.number().optional().nullable(),
    zip: z.string().max(20).optional().nullable(),
    ola: z.string().max(500).optional().nullable(),
    isActive: z.boolean().optional(),
}).refine((v) => Object.values(v).some((x) => x !== undefined), {
    message: 'At least one field must be provided',
});
export const LocationResponseSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    description: z.string().nullable(),
    shortName: z.string().nullable(),
    code: z.string().nullable(),
    address: z.string().nullable(),
    city: z.string().nullable(),
    cityId: z.number().nullable(),
    state: z.string().nullable(),
    stateId: z.number().nullable(),
    country: z.string(),
    countryId: z.number().nullable(),
    zip: z.string().nullable(),
    ola: z.string().nullable(),
    isActive: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
    createdBy: z.string().nullable().optional(),
    updatedBy: z.string().nullable().optional(),
});
export const ListLocationsResponseSchema = z.object({
    locations: z.array(LocationResponseSchema),
});
// Branch
export const CreateBranchSchema = z.object({
    locationId: z.string().uuid().optional().nullable(),
    name: z.string().min(1).max(255),
    description: z.string().max(1000).optional(),
    shortName: z.string().max(100).optional(),
    code: z.string().max(50).optional(),
    address: z.string().max(500).optional(),
    city: z.string().max(128).optional(),
    state: z.string().max(128).optional(),
    zip: z.string().max(20).optional(),
    ola: z.string().max(500).optional(),
    duration: z.number().int().min(0).optional(),
    isActive: z.boolean().optional().default(true),
});
export const UpdateBranchSchema = z.object({
    locationId: z.string().uuid().optional().nullable(),
    name: z.string().min(1).max(255).optional(),
    description: z.string().max(1000).optional().nullable(),
    shortName: z.string().max(100).optional().nullable(),
    code: z.string().max(50).optional().nullable(),
    address: z.string().max(500).optional().nullable(),
    city: z.string().max(128).optional().nullable(),
    state: z.string().max(128).optional().nullable(),
    zip: z.string().max(20).optional().nullable(),
    ola: z.string().max(500).optional().nullable(),
    duration: z.number().int().min(0).optional(),
    isActive: z.boolean().optional(),
}).refine((v) => Object.values(v).some((x) => x !== undefined), {
    message: 'At least one field must be provided',
});
export const BranchResponseSchema = z.object({
    id: z.string().uuid(),
    locationId: z.string().uuid().nullable(),
    locationName: z.string().nullable(),
    name: z.string(),
    description: z.string().nullable(),
    shortName: z.string().nullable(),
    code: z.string().nullable(),
    address: z.string().nullable(),
    city: z.string().nullable(),
    state: z.string().nullable(),
    zip: z.string().nullable(),
    ola: z.string().nullable(),
    duration: z.number().int().nullable(),
    isActive: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
    createdBy: z.string().nullable().optional(),
    updatedBy: z.string().nullable().optional(),
});
export const ListBranchesResponseSchema = z.object({
    branches: z.array(BranchResponseSchema),
});
// Department
export const CreateDepartmentSchema = z.object({
    locationId: z.string().uuid().optional().nullable(),
    branchId: z.string().uuid().optional().nullable(),
    name: z.string().min(1).max(255),
    description: z.string().max(1000).optional(),
    shortName: z.string().max(100).optional(),
    code: z.string().max(50).optional(),
    ola: z.string().max(500).optional(),
    isActive: z.boolean().optional().default(true),
});
export const UpdateDepartmentSchema = z.object({
    locationId: z.string().uuid().optional().nullable(),
    branchId: z.string().uuid().optional().nullable(),
    name: z.string().min(1).max(255).optional(),
    description: z.string().max(1000).optional().nullable(),
    shortName: z.string().max(100).optional().nullable(),
    code: z.string().max(50).optional().nullable(),
    ola: z.string().max(500).optional().nullable(),
    isActive: z.boolean().optional(),
}).refine((v) => Object.values(v).some((x) => x !== undefined), {
    message: 'At least one field must be provided',
});
export const DepartmentResponseSchema = z.object({
    id: z.string().uuid(),
    locationId: z.string().uuid().nullable(),
    locationName: z.string().nullable(),
    branchId: z.string().uuid().nullable(),
    branchName: z.string().nullable(),
    name: z.string(),
    description: z.string().nullable(),
    shortName: z.string().nullable(),
    code: z.string().nullable(),
    ola: z.string().nullable(),
    isActive: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
    createdBy: z.string().nullable().optional(),
    updatedBy: z.string().nullable().optional(),
});
export const ListDepartmentsResponseSchema = z.object({
    departments: z.array(DepartmentResponseSchema),
});
// Query
export const ListDomainsQuerySchema = z.object({
    search: z.string().optional(),
    includeInactive: z.string().optional().transform((v) => v === 'true'),
    page: z.string().optional().transform((v) => (v ? Number.parseInt(v, 10) : 1)),
    limit: z.string().optional().transform((v) => (v ? Number.parseInt(v, 10) : 10)),
});
//# sourceMappingURL=domains.js.map